import { useState, useLayoutEffect } from 'react'
import { useDatePicker2 } from '@/components/MyDatePicker'
import { getLastCompleteDate } from '@/lib/date-utils'
import { computeRoasDatePickerDefaultState } from '@/lib/roas-date-picker-defaults'
import Loader from '@/components/zthd/Loader'

/**
 * 在拉取 /troas 前，把 useDatePicker2 与 MyDatePicker 的「显示不完整数据 / 结束日」默认逻辑对齐。
 * 逻辑与 computeRoasDatePickerDefaultState 一致；MyDatePicker 晚于首帧 paint 再改会触发两帧两套 query。
 *
 * 开发环境 React Strict Mode 可能双挂载，首帧会再出现一次 Loader，生产无此行为。
 */
export function RoasDatePickerTroasGate({ isTotal, children }) {
  const [ready, setReady] = useState(false)

  useLayoutEffect(() => {
    const completeDateStr = String(getLastCompleteDate(true))
    useDatePicker2.setState((s) =>
      computeRoasDatePickerDefaultState(s, {
        defaultAllowIncomplete: !isTotal,
        completeDateStr,
      }),
    )
    setReady(true)
  }, [isTotal])

  if (!ready) {
    return <Loader>Loading...</Loader>
  }
  return children
}
